/* K MANNAM v28: no cart/ZIP/rate mutations. Existing theme owns drawer open/close. */
(function () {
  'use strict';
  if (window.KMMobileV28) return;
  var desktop = window.matchMedia('(min-width: 1000px)');
  var menus = new Map();
  var icons = new Map();
  var frame = 0;

  function setProperty(element, name, value) {
    if (element.style.getPropertyValue(name) !== value) element.style.setProperty(name, value);
  }
  function measureMenu(menu) {
    if (desktop.matches) return;
    var headerSection = menu.closest('[data-section-type="header"]') || menu.closest('.shopify-section__header');
    var anchor = headerSection || menu.closest('header');
    var parent = menu.offsetParent;
    if (!anchor || !parent || anchor.getBoundingClientRect().width === 0) return;
    var bounds = anchor.getBoundingClientRect();
    var bottom = bounds.bottom;
    var parentTop = parent.getBoundingClientRect().top + parent.clientTop - parent.scrollTop;
    var viewport = window.visualViewport;
    var viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
    // Keep fractional pixels: rounding both the header and top can leave a visible seam.
    setProperty(menu, '--km-mobile-menu-left', (bounds.left - parent.getBoundingClientRect().left - parent.clientLeft + parent.scrollLeft) + 'px');
    setProperty(menu, '--km-mobile-menu-width', bounds.width + 'px');
    setProperty(menu, '--km-mobile-menu-top', Math.max(0, bottom - parentTop) + 'px');
    setProperty(menu, '--km-mobile-menu-height', Math.max(0, viewportBottom - bottom) + 'px');
  }
  function scheduleMeasure() {
    if (frame) return;
    frame = window.requestAnimationFrame(function () {
      frame = 0;
      menus.forEach(function (_, menu) { if (menu.isConnected) measureMenu(menu); });
    });
  }
  function resetMenu(menu) {
    menu.querySelectorAll('[data-km-mobile-toggle]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
      var panel = document.getElementById(button.getAttribute('aria-controls'));
      if (panel && menu.contains(panel)) panel.hidden = true;
    });
  }
  function bindMenu(menu) {
    var observer = new MutationObserver(function () {
      if (menu.getAttribute('aria-hidden') === 'true') resetMenu(menu);
      // Measure synchronously after the native theme's open/close changes.
      measureMenu(menu);
    });
    observer.observe(menu, { attributes: true, attributeFilter: ['aria-hidden'] });
    var resize = null;
    if (window.ResizeObserver) {
      resize = new ResizeObserver(scheduleMeasure);
      var section = menu.closest('.shopify-section__header') || menu.closest('header');
      var stack = menu.closest('[data-km-header-stack]');
      if (section) resize.observe(section);
      if (stack) resize.observe(stack);
    }
    menus.set(menu, { observer: observer, resize: resize });
    measureMenu(menu);
  }
  function updateIcons(root, state) {
    var list = root.querySelector('.category-btn-list');
    var container = root.querySelector('.category-btn-list-cover');
    var wrapper = root.querySelector('.main-category-btn-wrapper');
    if (!list || !container || !wrapper) return;
    var useSlider = desktop.matches && list.children.length > 10;
    if (state.swiper && (!useSlider || state.swiper.destroyed)) {
      if (!state.swiper.destroyed) state.swiper.destroy(true, true);
      state.swiper = null;
    }
    wrapper.classList.toggle('swipe-disabled', !useSlider);
    if (useSlider && !state.swiper && typeof window.Swiper === 'function') {
      state.swiper = new window.Swiper(container, {
        slidesPerView: 10, slidesPerGroup: 10, spaceBetween: 20, loop: false,
        watchOverflow: true, pagination: false,
        navigation: {
          nextEl: root.querySelector('.swiper-button-next'),
          prevEl: root.querySelector('.swiper-button-prev')
        }
      });
    } else if (useSlider && state.swiper) {
      state.swiper.update();
    }
    // No hidden 'more' items, screen.width checks, or document-wide icon selectors.
  }
  function scan() {
    menus.forEach(function (state, menu) {
      if (!menu.isConnected) {
        state.observer.disconnect();
        if (state.resize) state.resize.disconnect();
        menus.delete(menu);
      }
    });
    icons.forEach(function (state, root) {
      if (!root.isConnected) {
        if (state.swiper && !state.swiper.destroyed) state.swiper.destroy(true, true);
        icons.delete(root);
      }
    });
    document.querySelectorAll('[data-km-mobile-menu]').forEach(function (menu) {
      if (!menus.has(menu)) bindMenu(menu);
    });
    document.querySelectorAll('[data-km-icon-slider]').forEach(function (root) {
      if (!icons.has(root)) icons.set(root, { swiper: null });
      updateIcons(root, icons.get(root));
    });
    scheduleMeasure();
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-km-mobile-toggle]');
    if (!button) return;
    var menu = button.closest('[data-km-mobile-menu]');
    var panel = document.getElementById(button.getAttribute('aria-controls'));
    if (!menu || !panel || !menu.contains(panel)) return;
    event.preventDefault();
    var expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    panel.hidden = expanded;
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var menu = event.target.closest && event.target.closest('[data-km-mobile-menu]');
    if (!menu || menu.getAttribute('aria-hidden') !== 'false') return;
    var nav = menu.closest('.header__mobile-nav');
    var toggle = nav && nav.querySelector('[data-action="toggle-menu"][aria-expanded="true"]');
    if (toggle) { event.preventDefault(); toggle.click(); toggle.focus({ preventScroll: true }); }
  });
  if (desktop.addEventListener) desktop.addEventListener('change', scan);
  else desktop.addListener(scan);
  window.addEventListener('resize', scheduleMeasure, { passive: true });
  window.addEventListener('scroll', scheduleMeasure, { passive: true });
  window.addEventListener('pageshow', scan);
  window.addEventListener('load', scan, { once: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleMeasure, { passive: true });
    window.visualViewport.addEventListener('scroll', scheduleMeasure, { passive: true });
  }
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', function () { window.requestAnimationFrame(scan); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleMeasure);
  window.KMMobileV28 = { scan: scan, measure: scheduleMeasure };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
})();
